import React, { useContext } from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import Navigation from '../../../layout/Navigation/Navigation';
import { componentPagesMenu, pageLayoutTypesPagesMenu } from '../../../menu';
import useDeviceScreen from '../../../hooks/useDeviceScreen';
import CommonHeaderRight from './CommonHeaderRight';
import {
	ASIDE_WIDTH_PX,
	SPACER_PX,
	MOBILE_BREAKPOINT_SIZE,
	ASIDE_MINIMIZE_BREAKPOINT_SIZE,
} from '../../../styles/settings/constants';
import ThemeContext from '../../../contexts/themeContext';

const DefaultHeader = () => {
	const { width } = useDeviceScreen();
	const { mobileDesign } = useContext(ThemeContext);
	return (
		// <div style={!mobileDesign ? { zIndex: -1000 } : undefined}>
		<Header>
			<HeaderLeft>
				{/* <Navigation
					menu={{ }}
					id='header-top-menu'
					horizontal={
						!!width && width >= Number(MOBILE_BREAKPOINT_SIZE)
					}
				/> */}
				<></>
			</HeaderLeft>
			<CommonHeaderRight />
		</Header>
		// </div>
	);
};

export default DefaultHeader;
